import React from 'react';
import { isRollout0Feature, trustSignals, contactInfo } from '../../config/featureFlags';

const TrustSignals: React.FC = () => {
  if (!isRollout0Feature('trustSignals')) return null;

  const items = [
    { value: trustSignals.yearsExperience, label: 'Years Experience' },
    { value: trustSignals.projectsCompleted, label: 'Roofs Completed' },
    { value: `⭐ ${trustSignals.ratings.google}`, label: 'Google Rating' },
    { value: '✓', label: contactInfo.insuranceCoverage },
  ];

  return (
    <div className="bg-gradient-to-r from-slate-800 via-slate-900 to-slate-800 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((item, i) => (
            <div key={i} className="text-center p-3 rounded-lg bg-white/5">
              <div className="text-2xl sm:text-3xl font-extrabold text-lime-400 mb-0.5">
                {item.value}
              </div>
              <div className="text-xs sm:text-sm text-gray-400 font-medium">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;
